import * as React from 'react';

import { ListPerformanceProps } from '../../components/list/performance';
import ListProduction from '../../components/list/production';

const ListPerformanceView: React.StatelessComponent<ListPerformanceProps> = props => {

    return (
        <li className="ace-production-row">
            <div className="stack-sm">
                <p className="h6-style">{props.performance.performanceDateDayString}</p>
                <p className="h6-style">{props.performance.performanceTimeString}</p>
            </div>
            {
                props.showReserveButton ?
                    <p>
                        <button className={props.performanceInCart ? 'btn-themed' : 'btn-primary'} disabled={!props.performanceInCart && !props.allowReserve} onClick={() => {
                            if (props.performanceInCart) {
                                props.removeFromCart(props.performance.performanceId);
                            } else {
                                props.selectPerformance(props.performance, props.useUnSeatedReservation);
                                props.toggleShowPerformances();
                            }
                        }}>
                            {props.performanceInCart ? props.text.removeButtonText : props.text.addToCartButtonText}
                        </button>
                    </p>
                    : null
            }

        </li>
    );
}

export default ListPerformanceView;